import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService, AppSettings, HelperService } from '../../../services/_services';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

declare var document, $;

@Component({
  selector: 'app-writers-dashboard',
  templateUrl: './writers-dashboard.component.html',
  styleUrls: ['./writers-dashboard.component.css']
})
export class WritersDashboardComponent implements OnInit {
  writersDbLogo: string = '';
  public welcomeText : any = "Hi, Welcome to your portal.";
  public loading     : any = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authenticationService : AuthenticationService,
    private router                : Router,

  ) { }

  ngOnInit(): void {
    const baseUrl = this.document.location.origin;

    // Set the logo URL based on the base URL
    if (baseUrl.includes('writing4money')) {
      this.writersDbLogo = 'assets/images/w4m-db-logo.svg'; // Default logo
    } else {
      
      this.writersDbLogo = 'assets/images/writers-db-logo.png'; // Replace with your logo for route1
    }
  }

  changeText(text){
      if(text == "available-orders"){
          this.welcomeText = "Click to view available orders.";
      }
      else if(text == "Order-in-progress"){
          this.welcomeText = "Click to view orders in progress.";
      }
      else if(text == "completed-orders"){
          this.welcomeText = "Click to view completed orders.";
      }
      else if(text == "revisions"){
          this.welcomeText = "Click to view requested revisions.";
      }
      else if(text == "manage-profile"){
          this.welcomeText = "Click to edit your profile.";
      }
      else if(text == "default"){
          this.welcomeText = "Hi, Welcome to your portal.";
      }
  }
  logout() {
    // this.authenticationService.simpleLogout();
    // this.router.navigate(['/login']);

    // Show Loader
    this.loading = true;

    this.authenticationService.logout().then(resp => {
        // console.log("resp: ",resp);
        this.router.navigate(['/login']);

        // Hode Loader
        this.loading = false;
    }).catch(error => {
        console.log("error: ",error);

        // Hode Loader
        this.loading = false;
    })
  }

}
